<div class="scan-mobile-content">
  <div class="customer-details">
    <div class="customer-details__title">
      Order details:
      <span role="button" class="close-btn">
        <img mat-dialog-close src="/assets/images/scan/close_icon.svg" alt="" />
      </span>
    </div>
    <div>{{ order.shippingName }}</div>
    <div>{{ order.shippingAddress.address1 }} &nbsp; {{ order.shippingAddress.address2 }}</div>
    <div>{{ order.shippingAddress.city }}, {{ order.shippingAddress.country }}</div>
    <div>{{ order.shippingAddress.zip }}</div>
    <div></div>
    <mat-divider class="customer-details__divider"></mat-divider>
    @if (order.orderBatch.selectedCarrier.name) {
    <div>
      <carrier-logo [carrierName]="order.orderBatch?.selectedCarrier?.name"></carrier-logo>
    </div>
    }
    <p class="customer-details__note-font">{{ order.deliveryMethod }}</p>
    <mat-divider class="customer-details__divider"></mat-divider>

    <div class="customer-details__note">
      <img mat-dialog-close src="/assets/icons/notes-customer.png" alt="" style="padding-right: 5px" />
      Note from customer
    </div>
    @if (order.note === '' ) {
    <p class="customer-details__note-font">There is no note on this order.</p>
    }
    <p class="customer-details__note-font">{{ order.note }}</p>
    <mat-divider class="customer-details__divider"></mat-divider>
    <img
      class="customer-details__print"
      src="../../../../../assets/images/print/print_icon.svg"
      alt=""
      (click)="openBulkPrint(order.id)" />
  </div>
</div>
